<template>
  <div class="columns my-0">
    <div class="column is-4">
      <kst-input load-on-focus floating-label
        field="Search" :data="searchData" :catalog="SearchCatalog"
        @input="handleInput"
      />
    </div>

    <div class="column is-narrow">
      <kst-input floating-label
        field="Vendor"
        :data="searchData"
        :catalog="SearchCatalog"
        @input="handleInput"
      >
      <template #right>
        <div class="control">
          <template v-if="searchData.Vendor !== ''">
            <kst-tooltip clear-mode hover-only :content="SearchCatalog.Vendor.Label">
              <kst-button clear-mode @click="handleReset"/>
            </kst-tooltip>
          </template>
          <template v-else>
          </template>
        </div>
      </template>
      </kst-input>
    </div>

    <div class="column is-narrow">
      <kst-input floating-label
        field="Date" :data="searchData" :catalog="SearchCatalog"
        @input="handleInput"
      />
    </div>

    <div class="column is-narrow">
      <kst-button reset-mode @click="handleReset"/>
    </div>
  </div>
</template>

<script>
import SearchCatalog from "./ReceiveSearchCatalog.js";

export default {
  props: {
    searchData: Object
  },
  data: () => ({
    SearchCatalog: SearchCatalog
  }),
  methods: {
    handleInput() {
      this.$emit(this.$kst.Enum.Event.Submit);
    },
    handleReset() {
      this.$emit(this.$kst.Enum.Event.Reset);
    }
  }
}
</script>